import { AddUpdateImportantEventDTO, ImportantEventFormFields } from 'types';
import { parseDayjsDateIntoString } from 'utils/parsers/dateTime/parseDayjsDateIntoString';

export const parseImportantEventFormFieldsIntoAddUpdateImportantEventDTO: (
    importantEventFormFields: ImportantEventFormFields,
) => AddUpdateImportantEventDTO = ({ date, ...restData }) => ({
    ...restData,
    date: parseDayjsDateIntoString(date, 'YYYY-MM-DD'),
});
